export enum CurrencyType {
  INR = 'INR',
  USD = 'USD'
}
